/* eslint-disable no-unused-vars */
import { Box, Button, Typography, IconButton, Fab } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ProformaNoteEntryForm from "./form";
import voucherHeaderForm from "./form";
import { VoucherLineColumns } from "../../../data/DynamicTable/Collumns";
import { accountsmanagement } from "../../../config";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { allUsersQuery } from "../../../data/Axios/queries";
import { useNavigate, useLocation} from "react-router-dom";

const base_url = accountsmanagement.uri;
function VoucherLinesTable() {
  const location = useLocation();

  const data = 
    location.state?.PVData ||
    JSON.parse(localStorage.getItem("PVData"));
  const navigate = useNavigate();

//  const handleGoBack = () => {
//   const backPath = location.state?.from || "/payment-voucher";
//     navigate(backPath);
//   };

  const actions = {
    entity: "Payment Voucher",
    isStatus: true,
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    // add: {
    //   key: "ADD",
    //   button_name: "Add",
    //   Show_Button: true,
    //   permission: "CreatePermission",
    // },
    dataObject: {
      inputObjectName: "paymentVoucherLinesView",
      inputSubObjectName: "paymentVoucherLines",
      inputFields: {
        paymentVoucherId: data?.id,
      },
      returnFields: [
        "id",
        "paymentVoucherId",
        "voucherNumber",
        "lineNumber",
        "payeeTypeId",
        "payeeTypeName",
        "payeeId",
        "payeeName",
        "referenceId",
        "referenceNumber",
        "accountTypeId",
        "accountTypeName",
        "accountId",
        "accountName",
        "description",
        "amount",
        "withholdingTaxId",
        "withholdingTaxRate",
        "withholdingTaxAmount",
        "vatId",
        "vatAmount",
        "netLineAmount",
        "isAdvance",
        "isPosted",
        "allocationStatus",
        "allocatedAmount",
        "isActive",
        "createdBy",
        "createdDate",
        "updatedBy",
        "updatedDate",
      ], // Added courtId
    },
  };

  return (
    <Box m="10px">
      {/* Floating Back Button */}
      <Fab
        color="secondary"
        aria-label="go back"
        //onClick={handleGoBack}
        sx={{
          position: "fixed",
          top: 120,      
          left: 270,     
          zIndex: 1100,
          width: 35,
          height: 35,
          boxShadow: 3,
          "&:hover": {
            boxShadow: 6,
          },
        }}
      >
        <ArrowBackIcon />
      </Fab>

      <DynamicTable
        title="Payment Vouchers Lines"
        subtitle="View all payment voucher line, create and edit voucher lines"
        columns={VoucherLineColumns}
        FormComponent={voucherHeaderForm}
        // query={vouvherl}
        base_url={base_url}
        actions={actions}
        //onAction={handleAction} // This now triggers navigation for relievers
      />
    </Box>
  );
}

export default VoucherLinesTable;